// src/anim/mirror.ts — Klip aynalama (ANIMATION §3, ARCHITECTURE §5.3). Rig_Medium dinlenme pozu YZ düzlemine göre tam simetrik
// ölçüldüğünden (t_r = (−x,y,z)·t_l, q_r = (x,−y,−z,w)·q_l, hata 0.0000) aynalama YEREL uzayda, dinlenme düzeltmesi olmadan doğrudur:
// M = diag(−1,1,1) yansıması altında R' = M·R·M ⇒ kuaterniyon (x,y,z,w) → (x,−y,−z,w); konum x → −x; ölçek aynı.
// Kanal adı takası: `<node>.<prop>` — node sonu 'l' ↔ 'r' (iskelette karşılığı varsa); merkez kemikler (root/hips/spine/chest/head)
// ad değiştirmez ama DEĞERLERİ yine aynalanır (hips −12° yaw → +12°, kök hareketin sol bileşeni sağa döner).
// Yeni ad `name + '~'` (CLIPS sonek sözleşmesi), aynı duration, aynı blendMode (dördüncü parametre atlanırsa Normal'e düşer — additive tuzağı).
// Yükleme anında bir kez çalışır (ClipLibrary); sıcak yol değil.
import * as THREE from 'three';

/** Aynalanmış kanal adı: 'upperarml' → 'upperarmr' (karşılığı iskelette varsa); 'hips' → 'hips'. */
export function mirrorNodeName(node: string, boneNames: ReadonlySet<string>): string {
  const base = node.slice(0, -1), side = node.slice(-1);
  if (side === 'l' && boneNames.has(base + 'r')) return base + 'r';
  if (side === 'r' && boneNames.has(base + 'l')) return base + 'l';
  return node;
}

/** Tek bir track'i aynalar (kopya döner; kaynak bozulmaz). */
export function mirrorTrack(src: THREE.KeyframeTrack, boneNames: ReadonlySet<string>): THREE.KeyframeTrack {
  const dot = src.name.lastIndexOf('.');
  const node = src.name.slice(0, dot), prop = src.name.slice(dot + 1);
  const t = src.clone();                       // times/values Float32Array kopyası
  t.name = mirrorNodeName(node, boneNames) + '.' + prop;
  const v = t.values;
  if (prop === 'position') {
    for (let i = 0; i < v.length; i += 3) v[i] = -(v[i] as number) + 0;   // +0: −0 → 0
  } else if (prop === 'quaternion') {
    for (let i = 0; i < v.length; i += 4) { v[i + 1] = -(v[i + 1] as number) + 0; v[i + 2] = -(v[i + 2] as number) + 0; }
  }
  // scale: değişmez
  return t;
}

/** Klibi aynalar: `clip.name + '~'`; süre, interpolasyon, zaman eksenleri ve blendMode aynen taşınır. */
export function mirrorClip(clip: THREE.AnimationClip, boneNames: ReadonlySet<string>, name: string = clip.name + '~'): THREE.AnimationClip {
  const tracks = clip.tracks.map((t) => mirrorTrack(t, boneNames));
  return new THREE.AnimationClip(name, clip.duration, tracks, clip.blendMode);
}

/** Track adlarından kemik adı kümesi (mirrorNodeName için); library yükleme anında tüm kliplerden toplar. */
export function collectNodeNames(clips: readonly THREE.AnimationClip[], into: Set<string> = new Set()): Set<string> {
  for (const c of clips) for (const t of c.tracks) {
    const dot = t.name.lastIndexOf('.');
    into.add(dot >= 0 ? t.name.slice(0, dot) : t.name);
  }
  return into;
}
